import { useState, useRef, useEffect } from 'react';
import { ChevronDown, X } from 'lucide-react';
import { AMBER, BORDER_COLOR } from '../../styles/tokens';

export default function ProjectFilter({ projects, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function toggle(projectName) {
    const next = selected.includes(projectName)
      ? selected.filter(p => p !== projectName)
      : [...selected, projectName];
    onChange(next);
  }

  function clearAll(e) {
    e.stopPropagation();
    onChange([]);
  }

  const hasSelection = selected.length > 0;
  const label = hasSelection
    ? `${selected.length} proyecto${selected.length !== 1 ? 's' : ''}`
    : 'Todos los Proyectos';

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(prev => !prev)}
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '6px 12px', fontSize: 13, fontWeight: hasSelection ? 600 : 500,
          borderRadius: 20, cursor: 'pointer', fontFamily: 'Inter, sans-serif',
          border: hasSelection ? `1.5px solid ${AMBER}` : `1px solid ${BORDER_COLOR}`,
          background: hasSelection ? 'rgba(217,119,6,0.08)' : '#fff',
          color: hasSelection ? AMBER : '#475569',
          whiteSpace: 'nowrap',
          height: 34, minWidth: 160,
        }}
      >
        <span>{label}</span>
        {hasSelection ? (
          <X size={13} onClick={clearAll} style={{ cursor: 'pointer' }} />
        ) : (
          <ChevronDown size={13} />
        )}
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, marginTop: 4,
          background: '#fff', border: `1px solid ${BORDER_COLOR}`,
          borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
          zIndex: 50, minWidth: 220, maxHeight: 280, overflowY: 'auto',
          padding: '6px 0',
        }}>
          {projects.length === 0 ? (
            <div style={{ padding: '10px 14px', fontSize: 12, color: '#94a3b8' }}>
              Sin proyectos
            </div>
          ) : (
            projects.map(name => {
              const isSelected = selected.includes(name);
              return (
                <label
                  key={name}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '7px 14px', cursor: 'pointer', fontSize: 13,
                    background: isSelected ? 'rgba(217,119,6,0.06)' : 'transparent',
                    color: '#1e293b', fontWeight: isSelected ? 600 : 400,
                  }}
                  onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = '#f8fafc'; }}
                  onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => toggle(name)}
                    style={{ accentColor: AMBER }}
                  />
                  {name}
                </label>
              );
            })
          )}
          {hasSelection && (
            <div style={{ borderTop: `1px solid ${BORDER_COLOR}`, padding: '6px 14px' }}>
              <button
                onClick={(e) => { e.stopPropagation(); onChange([]); }}
                style={{
                  background: 'none', border: 'none', fontSize: 12,
                  color: '#64748b', cursor: 'pointer', fontFamily: 'Inter, sans-serif',
                  textDecoration: 'underline', padding: 0,
                }}
              >
                Limpiar filtro
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
